import { isInsideBrowser } from './common';

/**
 * scriptUrl - the script URL to load in <script src>
 * targetTagName - the first tag to import the script e.g. <head>
 */
export const loadScriptToTag = async (
  scriptUrl: string,
  targetTagName: string,
  position: 'start' | 'end' = 'end',
) => {
  return new Promise<boolean>((resolve, reject) => {
    if (!isInsideBrowser) {
      reject('Not inside browser');
      return;
    }
    try {
      if (!scriptUrl) {
        reject(new Error('Script URL is undefined.'));
        return;
      }
      const doc = document.getElementsByTagName(targetTagName)[0];
      if (!doc) {
        reject(new Error(`Tag name ${targetTagName} not found.`));
        return;
      }
      const script = document.createElement('script');
      const firstChild = doc.firstChild;
      script.setAttribute('type', 'text/javascript');
      script.setAttribute('src', scriptUrl);
      script.onload = () => {
        resolve(true);
      };
      script.onerror = (error) => {
        reject(error);
      };
      if (position === 'start') {
        doc.insertBefore(script, firstChild);
      } else {
        doc.appendChild(script);
      }
    } catch (error) {
      reject(error);
    }
  });
};
